export * as Api from './api';

export enum FeeAccounting {
  ChargedToInvestor = 'CHARGED_TO_INVESTOR',
  Accrued = 'ACCRUED',
}

export enum FeeChargingFrequency {
  Monthly = 'MONTHLY',
  Yearly = 'YEARLY',
  Quarterly = 'QUARTERLY',
}

export enum FeeType {
  Initial = 'INITIAL',
  Recurring = 'RECURRING',
  Commission = 'COMMISSION',
  Performance = 'PERFORMANCE',
  Fee = 'ONE OFF FEE',
  Discount = 'ONE OFF DISCOUNT',
  Adviser = 'ADVISER',
  Transaction = 'TRANSACTION',
  Withdrawal = 'WITHDRAWAL FEE',
  InvestorDiscount = 'INVESTOR_DISCOUNT',
}

export enum FeeCalculationBasis {
  Fixed = 'FIXED',
  PercentageOfTotalCommitment = 'PERCENTAGE',
  PercentageOfUnrealisedAssetCost = 'PERCENTAGE_UAC',
}

export enum CoreFeeType {
  InitialPercentage = 'INITIAL %',
  RecurringPercentage = 'RECURRING %',
  InitialFixed = 'INITIAL £',
  RecurringFixed = 'RECURRING £',
}

export enum FeeHurdleBasis {
  Company = 'COMPANY',
  Investment = 'INVESTMENT',
}

export enum PaymentEmailStatus {
  UnpaidEmail = 'UNPAID_EMAIL',
  UnpaidPaymentReminderEmail = 'UNPAID_PAYMENT_REMINDER_EMAIL',
  UnpaidNoEmail = 'UNPAID_NO_EMAIL',
  UnpaidDisableEmail = 'UNPAID_DISABLE_EMAIL',
  PaidEmail = 'PAID_EMAIL',
  PaidNoEmail = 'PAID_NO_EMAIL',
  PaidDisableEmail = 'PAID_DISABLE_EMAIL',
}

export enum InvestmentPaymentStatus {
  FullyFunded = 'FULLY_FUNDED',
  PartiallyFunded = 'PARTIALLY_FUNDED',
  NoPayment = 'NO_PAYMENT',
}

export enum InvestmentSource {
  Transfer = 'transfer',
  Upload = 'upload',
  Further = 'further',
}

export enum EisWizardInvestmentEnum {
  Eis = 'EIS',
  Seis = 'SEIS',
}

export enum InvestmentCompletionStatus {
  All = 'ALL',
  Completed = 'COMPLETED',
  Incomplete = 'INCOMPLETE',
}

export enum InvestmentArchiveStatus {
  All = 'all',
  NotArchived = 'not_archived',
  Archived = 'archived',
}

export enum InvestmentCustomTagCategory {
  Source = 'source',
  InternalContact = 'internal_contact',
  Other = 'other',
}

export interface ShareholdingTaxCertificateDetails {
  isDownloadTaxCertificatesAllowed: boolean;
  taxReliefEligible?: boolean;
  taxCertificateAvailable: boolean;
  taxReliefType?: EisWizardInvestmentEnum;
  taxCertificate: string | null;
  fundHasEis5Certificate?: boolean;
  createdAt?: Date;
}

export type IncompleteInvestment = {
  _id: string;
  fullName: string;
  firmName: string;
  fundName: string;
  fundId?: string;
  createdAt: string;
  step?: string;
  adviserId?: string;
  adviser?: {
    _id: string;
    fullName: string;
  } | null;
  adviserFee?: number;
  kycStatusLabel?: string;
  investmentAmount: number;
  deletedAt: string | null;
  investor: {
    _id: string;
    email: string;
  };
  firm?: {
    firmName: string;
  };
  fund?: {
    fundName: string;
  };
  status?: string;
  archivedForAdminAt?: string | null;
};

export interface CustomTag {
  category: InvestmentCustomTagCategory;
  tag: string;
}

export enum InvestorTag {
  RequiresHardCopyReports = 'requiresHardCopyReports',
  VulnerableClient = 'isVulnerableClient',
  Deceased = 'isDeceased',
}
